import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import TypeaheadField from '../../components/checkout/CreditAssessmentStep2/TypeaheadField';


const TypeaheadContainer = props =>
  <Field
    name={props.name}
    component={TypeaheadField}
    props={props}
  />
;

TypeaheadContainer.propTypes = {
  name: PropTypes.string
};

export default TypeaheadContainer;



/** WEBPACK FOOTER **
 ** ./src/redux/containers/TypeaheadContainer.js
 **/